import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { ensureNamespace, retainNamespace, getLocaleSnapshot, subscribeLocale, translate, type Params } from './runtime';

export function useTranslation(namespace = 'common') {
  const snapshot = useSyncExternalStore(subscribeLocale, getLocaleSnapshot, getLocaleSnapshot);
  const t = useCallback((key: string, params?: Params) => translate(key, params, namespace, snapshot.locale), [namespace, snapshot.locale]);
  useEffect(() => {
    if (namespace === 'common') return;
    const release = retainNamespace(namespace);
    void ensureNamespace(namespace).catch(() => { /* Boundary exposes download retry. */ });
    return release;
  }, [namespace, snapshot.locale]);
  return {
    ...snapshot,
    t,
  };
}
